import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import JsonData from "../data/data.json";
import { useState } from "react";

export const Navigation = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (hash) => (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate({ pathname: "/", hash });
      setTimeout(() => {
        const id = hash.replace("#", "#");
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 60);
    } else {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
      window.history.pushState(null, "", hash);
    }
  };

  const [showSolutions, setShowSolutions] = useState(false);

  const goToService = (slug) => (e) => {
    e.preventDefault();
    setShowSolutions(false);
    navigate(`/service/${slug}`);
  };

  const handleSolutionsClick = (e) => {
    if (window.innerWidth < 768) {
      e.preventDefault();
      setShowSolutions((s) => !s);
      return;
    }
    handleNav("#services")(e);
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/#page-top" onClick={handleNav('#page-top')} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img src={`${process.env.PUBLIC_URL}/img/kovid/kovid-logo.png`} alt="Kovid India" style={{ height: '60px', width: 'auto' }} />
            <span style={{ fontSize: '20px', color: '#333' }}>KOVID INDIA</span>
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {/* <li>
              <a href="#features" className="page-scroll">
                Features
              </a>
            </li> */}
            <li>
              <a href="/#about" className="page-scroll" onClick={handleNav('#about')}>
                About
              </a>
            </li>
            <li
              className="nav-solutions"
              onMouseEnter={() => window.innerWidth >= 768 && setShowSolutions(true)}
              onMouseLeave={() => window.innerWidth >= 768 && setShowSolutions(false)}
            >
              <a href="/#services" className="page-scroll" onClick={handleSolutionsClick}>
                Solutions
              </a>
              {showSolutions && JsonData.Services && (
                <div className="solutions-dropdown">
                  {JsonData.Services.map((s, i) => {
                    const slug = s.name.toLowerCase().replace(/\s+/g, "-");
                    return (
                      <a
                        key={`${slug}-${i}`}
                        href={`/service/${slug}`}
                        onClick={goToService(slug)}
                        className="solutions-dropdown-item"
                      >
                        {s.name}
                      </a>
                    );
                  })}
                </div>
              )}
            </li>
            {/* <li>
              <a href="/#portfolio" className="page-scroll" onClick={handleNav('#portfolio')}>
                Gallery
              </a>
            </li> */}
            <li>
              <a href="/#testimonials" className="page-scroll" onClick={handleNav('#testimonials')}>
                Clientele
              </a>
            </li>
            {/* <li>
              <a href="/#team" className="page-scroll" onClick={handleNav('#team')}>
                Team
              </a>
            </li> */}
            <li>
              <div>
                <a href="/#contact" className="btn btn-custom btn-lg page-scroll" onClick={handleNav('#contact')}>
                  Contact
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
